import { useContext } from "react";

import { DateOverrideContext } from "./dateOverrideContext";

export function useDateOverride() {
  const ctx = useContext(DateOverrideContext);
  if (ctx === null) {
    throw new Error("useDateOverride must be used within DateOverrideProvider");
  }
  return ctx;
}
